module.exports = __webpack_public_path__ + "img/public_5.ee040b59.jpg";